import * as React from "react";
import { HudNavigation } from "../../navigation/HudNavigation";
export var BF2HudBottom = function () { return React.createElement(HudNavigation, null); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudBottom.tsx
// module id = 2263
// module chunks = 3